<div class="container-box">
  <app-table-header
    tableTitle="VWFS Telai"
    (btnUpdateClick)="reloadTrigger$.next()"
  ></app-table-header>
  <div class="table-container">
    <app-new-table
      [dataSource]="dataSource"
      [reloadTrigger$]="reloadTrigger$"
      [displayedColumns]="displayedColumns"
      [initialSort]="{
        active: 'id',
        direction: 'desc'
      }"
      [hideButtonDetails]="true"
      (btnDetailsClickEvent)="btnDetailsClickFunction($event)"
    ></app-new-table>
  </div>
</div>
